import { z } from 'zod';

import { LessonTranslationsSchema } from '../lesson/lesson';

/**
 * The editable half of a lesson. `sortOrder` moves through the reorder
 * endpoint, never through the form — see `CourseWritableShape` for why.
 */
export const LessonWritableShape = {
  translations: LessonTranslationsSchema,
};

/**
 * Creating a lesson (`courses.manage`).
 *
 * `courseId` comes from the route, not the body: a lesson belongs to the course
 * whose collection it was posted to, and accepting it twice would let the two
 * disagree.
 */
export const LessonCreateSchema = z.object({ ...LessonWritableShape }).strict();

export type LessonCreateRequest = z.infer<typeof LessonCreateSchema>;
